import React from "react";
import PortfolioBlock from "./PortfolioBlock";
import { Box, Container, Grid } from "@mui/material";
import { info } from "../../info/Info";

export default function Portfolio() {
  return (
    <Box pt={8}>
      <Container maxWidth="xl">
        <Grid container display={"flex"} justifyContent={"center"}>
          {info.portfolio.map((project, index) => (
            <Grid item xs={12} md={6} key={index}>
              <PortfolioBlock
                image={project.image}
                live={project.live}
                title={project.title}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
